<template>
  <div>
    <masterList :tableColumns="tableColumns" :module="'products'" :addNew="addNew"></masterList>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import masterList from "../Components/masterList.vue";
export default {
  components: {
    masterList,
  },
  data() {
    return {
      addNew: "/products/detail/_new",
      tableColumns: [
        {
          prop: "code",
          label: "Code",
          minWidth: 80,
          sortable: true,
          key:"CODE"
        },
        {
          prop: "name",
          label: "Name",
          minWidth: 280,
          sortable: true,
          key:"NAME"
          
        },
        {
          prop: "gtin",
          label: "GTIN",
          minWidth: 100,
          sortable: true,
          key:"GTIN"
        },
        // {
        //   prop: "base_uom",
        //   label: "UOM",
        //   minWidth: 100,
        //   sortable: true,
        //   key:"UOM"
        // },
        // {
        //   prop: "moq",
        //   label: "MOQ",
        //   minWidth: 100,
        //   sortable: true,
        //   key:"MOQ"
        // },
        {
          prop: "sale_list_price_display",
          label: "List Price",
          minWidth: 100,
          sortable: true,
          key:"LIST_PRICE"
        },
      ]
    };
  },
  mounted(){
    this.updateTableLang()
  },

  computed:{
    ...mapState({
      language_terms:(state)=>state.languages.language_terms
    })
  },

  watch:{
    language_terms:{
            handler(val){
                this.updateTableLang()
            },
        }
  },
  methods:{
      updateTableLang(){
      for(let i=0; i<this.tableColumns.length;i++){
         let key = this.tableColumns[i].key
         this.tableColumns[i].label = this.language_terms[key]

      }
    },

  }
};
</script>
<style>
</style>